import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router} from '@angular/router';
import {finalize, take} from 'rxjs/operators';
import {UserService} from '../../../services/user-services/user.service';
import {AuthenticationService} from '../../../services/authentication.service';
import {FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Location, NgClass, NgFor, NgIf} from '@angular/common';
import {LocalSettingsService} from 'src/app/services/local-settings.service';
import {DocumentsService} from '../../../services/user-services/documents.service';
import {ProcessSharedService} from '../../../services/process-shared.service';
//import {MetaService} from 'src/app/services/meta.service';
//import {TiktokService} from '../../../services/tiktok.service';
import {MatOptionModule} from '@angular/material/core';
import {NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import {CodePromoInputComponent} from '../../../shared/components/ux/inputs/code-promo-input/code-promo-input.component';
import {MatIconModule} from '@angular/material/icon';
import {NgbPopoverModule} from '@ng-bootstrap/ng-bootstrap';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {UploadFileComponent} from '../../../shared/components/upload-file/upload-file.component';
import {FaqAccordionComponent} from '../../../components/faq-accordion/faq-accordion.component';
import {HcComponentPostPaymentComponent} from './hc-component-post-payment/hc-component-post-payment.component';
import {HcComponentPaymentComponent} from './hc-component-payment/hc-component-payment.component';
import {HcComponentConfirmComponent} from './hc-component-confirm/hc-component-confirm.component';
import {HcComponentFormComponent} from './hc-component-form/hc-component-form.component';
import {ProcessNavbarComponent} from '../../../shared/components/inprocess-layout/process-navbar/process-navbar.component';
import {HcHomeComponent} from './hc-home/hc-home.component';
import {Payout} from '../../../models/payout';
import {HelperService} from "../../../services/helper.service";
import {IconComponent} from "../../../shared/components/icons-svgs/icons-svgs.component";
import {HcComponentExpiredComponent} from "./hc-component-expired/hc-component-expired.component";

@Component({
    selector: 'app-housing-certificate',
    templateUrl: './housing-certificate.component.html',
    styleUrls: ['./housing-certificate.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
  imports: [NgIf, HcHomeComponent, NgClass, ProcessNavbarComponent, HcComponentFormComponent, HcComponentConfirmComponent, HcComponentPaymentComponent, HcComponentPostPaymentComponent, FaqAccordionComponent, UploadFileComponent, ClipboardModule, NgbPopoverModule, MatIconModule, CodePromoInputComponent, MatFormFieldModule, MatSelectModule, FormsModule, ReactiveFormsModule, NgxIntlTelInputModule, NgFor, MatOptionModule, TranslateModule, IconComponent, HcComponentExpiredComponent]
})
export class HousingCertificateComponent implements OnInit {

  isMobile = false;
  page: string = null;
  links: any[] = [
    // {title: "COMMON.HOMEPAGE", link: '/housing-certificate/start', classes: '', redirect: true, page: 'start'},
    {title: "COMMON.INFORMATION", link: '/housing-certificate/informations', classes: 'disabled', redirect: false, page: 'informations'},
    {title: "Confirmation", link: '/housing-certificate/confirmation', classes: 'disabled', redirect: false, page: 'confirmation'},
    {title: "COMMON.PAYMENT.BASIC", link: '/housing-certificate/payment', classes: 'disabled', redirect: false, page: 'payment'},
  ]
  hasForcePage =false;
  text:any = {
    title: null,
    subtitle: null,
    text: null,
    reason: null,
    btn1: null,
    btn2: null,
  }

  // Utilisateur
  isLogged = false;
  promocode:any;
  itemId:number;

  // Refund
  refundFormControl: UntypedFormControl = new UntypedFormControl([])
  canRefund = false;
  refundError = false;
  isUsedCode = false;
  faqFields: any;

  // Re upload fields
  userDocument: any;
  isFormSubmitted = false;
  docForm: UntypedFormGroup;
  isLoading = false;
  price = 199;
  userState;
  currentUser;
  currentLanguage;
  public certificate: Payout;

  constructor(
    public translate: TranslateService,
    private route: ActivatedRoute,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private location: Location,
    private _localSettings: LocalSettingsService,
    private userDocumentService: DocumentsService,
    private processSharedService: ProcessSharedService,
    //private metaService : MetaService,
    //private tikTokService: TiktokService,
    private helperService: HelperService,


  ) {
    const userLang: string = this._localSettings.getLanguage()
    ? this._localSettings.getLanguage()
    : 'en';
  this.translate.use(userLang);
  this.currentLanguage = userLang;

    this.route.queryParams.subscribe(params => {
      if(params['force']){
        this.hasForcePage = params['force'];
      }
    });

  }

  ngOnInit(): void {
    this.router.navigate([], {
      queryParams: { force: null },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
    this.isMobile = this.userService.isMobileUser;
    this.isLoading = true;
    this.route.data.pipe(take(1)).subscribe(d => this.page = d.page);

    this.currentUser = this.userService.getInfos();
    //this.metaService.sendPageView('ViewHC',this.router.url,this.currentUser ? this.currentUser.id : 0,0,'hc').subscribe();

    if (this.authenticationService.currentUserValue) {
      this.isLogged = true;
      if(!this.hasForcePage){
        this.userService.getPayout('housing-certificate').pipe(take(1)).subscribe(data => {
          this.certificate = data;
          if (data) {
            let url, faq;
            this.itemId     = data.id;
            this.userState  = data.status;

            switch (data.status) {

              case 'Pending-document' : {
                url = data.status.toLowerCase();
                this.page = data.status;
                faq = 'attestation-documents';
                this.docForm = this.formBuilder.group({'VISA_REFUSED': [null, Validators.required]});
                this.getDocument();
                this.isLoading = false;
                break;
              }
              case 'Pending-refund' : {
                url = 'pending';
                this.page = data.status;
                faq = 'attestation-pending';
                let hubspotDatas = {
                  campagne: '',
                  source: '',
                  medium: ''
                };
                hubspotDatas = this.helperService.setUtmToHubspot(hubspotDatas);
                this.userService.setHubspotDeal(6459040, 20596146, hubspotDatas).subscribe();
                this.text.title = 'PROCESSES.HOUSING_CERTIFICATE.PENDING.TITLE';
                this.text.subtitle = 'PROCESSES.HOUSING_CERTIFICATE.PENDING.SUBTITLE';
                this.text.text = 'PROCESSES.HOUSING_CERTIFICATE.PENDING.TEXT';
                this.text.btn2 = 'dashboard';
                this.isLoading = false;
                break;
              }
              case 'Refunded':
              case 'Not-refunded': {
                url = data.status.toLowerCase();
                this.page = url;
                if (url === 'not-refunded') {
                  faq = 'attestation-no_refund';
                }
                if (data.refundDatas) {
                  const d = JSON.parse(data.refundDatas);
                  if (d.reason) {
                    this.setRefusalText('NOT_REFUNDED_' + d.reason);
                  } else {
                    this.setRefusalText(url);
                  }
                } else {
                  this.setRefusalText(url);
                }
                this.isLoading = false;
                break;
              }
              case 'Accepted':
              case 'Canceled' : {
                url = 'post-payment';
                this.page = url;
                this.userService.checkUsedPromoCode(37)
                  .pipe(take(1),
                    finalize(() => {
                      if (!this.isUsedCode) {
                        this.getPromoCode();
                      }
                    })
                  ).subscribe(data => {
                  this.isUsedCode = data ? data.value : false;
                });
                break;
              }
              case 'Expired': {
                this.page = 'expired';
                this.isLoading = false;
                break;
              }
            }

            if (url && !this.router.url.endsWith(url)) {
              this.location.replaceState(this.currentLanguage + "/housing-certificate/"+ url);
            } else if (faq) {
              this.processSharedService.getPageFaq(faq).pipe(take(1)).subscribe( (data) => {
                this.faqFields = data;
              } );
            }
          } else {
            if (this.page == 'Pending-refund' || this.page == 'refunded') {
              //this.tikTokService.sendPageView('URL achat attestation', this.router.url, this.currentUser ? this.currentUser.id : 0, 'page start paiement');
              this.router.navigate([this.currentLanguage +'/housing-certificate/start']);
            }

          }
        });
      }
    } else {
        if (this.page !== 'start' && this.page !== 'informations' ) {
          this.page = 'informations';
          this.location.replaceState(this.currentLanguage + "/housing-certificate/"+ this.page);
        }
      }
  }


  private setRefusalText(reason):void {
    this.text.title = 'PROCESSES.HOUSING_CERTIFICATE.' + reason.toUpperCase() + '.TITLE';
    if (reason !== 'NOT_REFUNDED_EXPIRED' && reason != 'NOT_REFUNDED_FALSE_DOCUMENT') {
      this.text.subtitle = 'PROCESSES.HOUSING_CERTIFICATE.' + reason.toUpperCase() + '.SUBTITLE';
    }
    this.text.text = 'PROCESSES.HOUSING_CERTIFICATE.' + reason.toUpperCase() + '.TEXT';
    this.text.btn1 = null;
    this.text.btn2 = 'dashboard';

  }

  /**
   * Récupère le code promo généré lors de l'achat.
   * Si le code promo a été utilisé, il ne sera pas affiché.
   * @private -> utilisé dans le OnInit(), switch case, default
   */
  private getPromoCode(): void {
    this.userService.getPromoCode({service: 'housing-certificate', process_key: 'ACCOMMODATION', abrv: 'HC'}).pipe(take(1)).subscribe(data => {
      this.promocode = data;
    });
  }



  goTo(url) {
    if (url === 'list') {
      let city = '';
      if (this.certificate) {
        const datas = JSON.parse(this.certificate.datas);
        if (datas) {
          const split = datas.address.split(' ');
          city = split[split.length - 1];
        }
      }
      this.router.navigate([this.currentLanguage + '/accommodation/list/' + city]);
    } else {
      this.router.navigate(['/account/visa/start']);
    }
  }

  /**
   *
   * @param e
   */
  forcePage(e) {
    this.page = e;
    this.hasForcePage = true;
    this.location.replaceState(this.currentLanguage + "/housing-certificate/"+ e);
    this.canRefund = false;
    this.refundError = false;
    this.refundFormControl.setValue([]);
  }

  /**
   *
   */
  refund() {
    const value = this.refundFormControl.value;
    if (!this.canRefund && value && value.length > 0) {
      this.canRefund = value.includes(5);
      if (this.canRefund) {
        this.docForm = this.formBuilder.group({'VISA_REFUSED': [null, Validators.required]});
      } else {
        this.refundError = true;
      }
    } else if (this.canRefund) {
      this.sendDocument();
    }
  }

  /**
   * Appelée uniquement si l'utilisateur est en pending-document (pas besoin du doc au premier upload)
   * Permet de styliser le texte de la page (illisible, incorrect..)
   */
  private getDocument(): void {
    this.userDocumentService.getDocuments('VISA_REFUSED')
      .pipe( take(1), finalize(() => {this.isLoading = false;}) )
      .subscribe(data => {
        this.text.title = 'PROCESSES.ACCOMMODATION.FAILED_DOCUMENTS.INCORRECT.TITLE';
        this.text.subtitle = 'PROCESSES.ACCOMMODATION.FAILED_DOCUMENTS.INCORRECT.SUBTITLE';
        this.userDocument = data.documents[0];
        if (this.userDocument && this.userDocument.pivot) {
          if (this.userDocument.pivot.state === 'unreadable' || this.userDocument.pivot.state === 'incorrect') {
            this.text.title = 'PROCESSES.ACCOMMODATION.FAILED_DOCUMENTS.'+ this.userDocument.pivot.state.toUpperCase() + '.TITLE';
            this.text.subtitle = 'PROCESSES.ACCOMMODATION.FAILED_DOCUMENTS.'+ this.userDocument.pivot.state.toUpperCase() + '.SUBTITLE';
          } else if (this.userDocument.pivot.state) {
            this.text.title = 'PROCESSES.ACCOMMODATION.FAILED_DOCUMENTS.CUSTOM.TITLE';
            this.text.subtitle = 'PROCESSES.ACCOMMODATION.FAILED_DOCUMENTS.INCORRECT.SUBTITLE';
            this.text.reason = this.userDocument.pivot.state;
          }
        }
      });
  }

  onFileDelete(e){
    const doc = e.documentType;
    this.docForm.controls[doc].setValue(null);
  }

  onFileUpload(e){
    const doc = e.documentType;
    this.docForm.controls[doc].setValue(true);
    this.refundError = false;
  }

  sendDocument() : void {
    this.isFormSubmitted = true;
    if (this.itemId && this.docForm.valid) {
      this.userService.updatePayout(this.itemId, {status:'Pending-refund'}).subscribe(data => {
        if(data.status && data.status == 'success'){
          if (this.page === 'Pending-document') location.reload();
          else  this.router.navigate([this.currentLanguage + '/housing-certificate/pending']);

        } else {
          this.docForm.controls.VISA_REFUSED.setErrors({code_used: true});
        }
      });
    }
  }

  public isAttestationExpired(date: string): boolean {
    if (!date) return false;

    const createdAt = new Date(date);
    const now = new Date();
    const limitDate = new Date();
    limitDate.setDate(now.getDate() - 45);

    return createdAt < limitDate;
  }

  userAction(element) {
    switch (element) {
      case 'domain': {
        this.router.navigate([this.currentLanguage + '/accommodation/list']);
        break;
      }
      default: {
        this.router.navigate([this.currentLanguage + '/discover']);
        break;
      }
    }
  }

  applyPromoCode(price) {
    this.price = price;
  }

}
